import { PricingTier } from '@varo/graphql-schema-types';
import GasOfferCard from 'features/rewards/components/GasOfferCard/GasOfferCard';
import React from 'react';
import { FlatList, StyleSheet, View } from 'react-native';
import theme from 'shared/styles/theme';

interface GasOfferCardCarouselProps {
  gasOffers: PricingTier[];
}

const GasOfferCardCarousel = ({ gasOffers }: GasOfferCardCarouselProps) => {
  return (
    <FlatList
      contentContainerStyle={styles.gasCardCarousel}
      data={gasOffers}
      renderItem={({ item, index }) => (
        <View style={index < gasOffers.length - 1 && styles.itemWrapper}>
          <GasOfferCard
            priceTitle={item.tierDisplayName}
            currentPrice={item.disountedPrice.formatted}
            actualPrice={item.originalPrice.formatted}
            pricePerUnit={item.cashbackPerUnit}
          />
        </View>
      )}
      keyExtractor={(item, index) => `${item.tierDisplayName}-${index}`}
      horizontal
      showsHorizontalScrollIndicator={false}
      removeClippedSubviews={false}
    />
  );
};

const styles = StyleSheet.create({
  gasCardCarousel: {
    paddingEnd: theme.spacing.m,
    paddingStart: theme.spacing.m,
  },
  itemWrapper: {
    marginRight: theme.spacing.s,
  },
});

export default GasOfferCardCarousel;
